<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiTrainBus  } from "@mdi/js"

export default {
  name: "TrashCanOutlineIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiTrainBus ,
    }
  }
}
</script>
